module.exports = __webpack_public_path__ + "img/Doc04-20030359-028_28_p1.6dede9c7.jpg";